import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';

// `_metronic/_assets/sass/vendors/react/material-ui/_general.scss` overrides
// `.MuiBackdrop-root` globally to a near-transparent background (legacy
// quick-actions panel); every MUI Dialog needs to reassert its own backdrop
// here or it renders almost invisible, letting the page behind bleed through.
export const StyledDialog = styled(Dialog)`
  .MuiBackdrop-root {
    background: rgba(0, 0, 0, 0.55) !important;
  }
`;
